import axios from 'axios';

class NewsletterSignup {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.input = self.elem.querySelector('[data-newsletter-signup-input]');
        self.errorMessage = self.elem.querySelector('[data-newsletter-signup-error-message]');
        self.redirect = self.elem.getAttribute('data-newsletter-signup-redirect');
    }

    init() {
        let self = this;

        self.elem.addEventListener('submit', evt => {
            evt.preventDefault();

            self.submitForm();
        });
    }

    submitForm() {
        let self = this;

        let formData = new FormData(self.elem);

        axios({
            method: "post",
            url: "/mailchimp/send",
            data: formData,
        })
            .then(function (response) {
                if(response.data.success == true) {
                    window.location.href = self.redirect;
                } else {
                    self.input.classList.add('is-invalid');
                    self.errorMessage.textContent = response.data.msg;
                }
            })
            .catch(function (response) {
                // Handle error
                console.log(response);
            });
    }
}

export default NewsletterSignup;